import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCinemaCopy } from "../../statics/cinemaCopy";
import { getProgramPosterUrl } from "../../utils/getProgramPosterUrl";
import { nowOnAir } from "../../utils/nowOnAir";
import useCarouselScroll from "../../utils/useCarouselScroll";
import defaultPoster from "../../assets/images/default-vod-horizontal-poster.png";
import ChannelLogo from "./ChannelLogo";
import CinemaIcon from "./CinemaIcon";
import "./NowOnAirShelf.scss";

const title = "Şimdi Yayında";

function ProgramCard({ channel, program }) {
  const poster = getProgramPosterUrl(program.posters) || defaultPoster;
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [poster]);
  return (
    <Link
      className="cinema-now-card"
      to={`/dashboard/livetv/${channel.id}`}
      aria-label={`${program.title} · ${channel.name}`}
      title={`${program.title} · ${channel.name}`}
    >
      <span className="cinema-now-artwork">
        <img
          className="cinema-now-poster"
          src={failed ? defaultPoster : poster}
          alt=""
          loading="lazy"
          decoding="async"
          draggable="false"
          onError={() => setFailed(true)}
        />
        <ChannelLogo channel={channel} />
      </span>
      <span className="cinema-now-title">{program.title}</span>
    </Link>
  );
}

export default function NowOnAirShelf({ channels, now, profileId }) {
  const copy = getCinemaCopy();
  const items = nowOnAir(channels, now);
  const { trackRef, canPrevious, canNext, move } = useCarouselScroll({
    itemCount: items.length,
    resetKey: profileId
  });
  if (!items.length) return null;
  return (
    <section className="cinema-shelf cinema-now-on-air" aria-label={title}>
      <div className="cinema-shelf-heading">
        <h2 className="label-title">{title}</h2>
        <div className="cinema-shelf-controls">
          <button
            type="button"
            className="cinema-icon-button"
            aria-label={`${copy.previous}: ${title}`}
            disabled={!canPrevious}
            onClick={() => move(-1)}
          >
            <CinemaIcon name="previous" />
          </button>
          <button
            type="button"
            className="cinema-icon-button"
            aria-label={`${copy.next}: ${title}`}
            disabled={!canNext}
            onClick={() => move(1)}
          >
            <CinemaIcon name="next" />
          </button>
        </div>
      </div>
      <div className="cinema-now-track" ref={trackRef}>
        {items.map(({ channel, program }) => (
          <ProgramCard key={channel.id} channel={channel} program={program} />
        ))}
      </div>
    </section>
  );
}
